// Shared form-validation helpers.

export const isValidEmail = (value) => !!value && /\S+@\S+\.\S+/.test(value);
